// extracted by mini-css-extract-plugin
export default {"container":"FormPartialPhoneNumber_container__IAo+6"};